/**
 * URL safety helper (v2-1).
 *
 * Proposal item URLs are operator-pasted and rendered on the PUBLIC client share
 * page into <a href>, <video><source src> and <iframe src>. A `javascript:`,
 * `data:` or `vbscript:` URL there would be an XSS vector. The backend already
 * rejects non-http(s) URLs (422), but we guard again at render time
 * (belt-and-suspenders): anything that isn't a plain http(s) absolute URL is
 * treated as unsafe and the caller renders an "unavailable" fallback instead of
 * the link/media.
 */

/** True only for absolute http:// or https:// URLs. */
export function isSafeHttpUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  let parsed: URL;
  try {
    parsed = new URL(url, window.location.origin);
  } catch {
    return false;
  }
  // new URL() resolves scheme-relative ("//host") / relative inputs against the
  // origin, so an unsafe scheme can only survive if it was explicit. Reject
  // anything that isn't http(s) (blocks javascript:, data:, vbscript:, file:, …)
  // AND require the original string to carry an explicit http(s) scheme so a
  // pasted "//evil" or relative path doesn't silently resolve to our origin.
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
  return /^https?:\/\//i.test(url.trim());
}
